<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Penalty Types</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
         <add-discipline-penalty-type
            v-if="pagepermission.insertable"
            @created="handleCreated"
          />
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <discipline-severity-type-table
              :rolesetting="pagepermission"
              :severity="data"
              :loading="loading"
              @updateTable="handleUpdateTable"
            />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
            showSizeChanger
            @showSizeChange="onShowSizeChange"
            :total="meta.total"
            :pageSize.sync="pageSize"
            v-model="current"
            @change="onChange"
          >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
            <p class="error" v-if="!permissionCheckSpinning">
              You don't have permission to use this feature.
            </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import DisciplineSeverityTypeTable from '@/components/disciplineManagement/disciplinePenaltyTypes/Table'
import AddDisciplinePenaltyType from '@/components/disciplineManagement/disciplinePenaltyTypes/Form/Add'

export default {
  components: {
    DisciplineSeverityTypeTable,
    AddDisciplinePenaltyType,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('class', 22)
    rc.then((data) => {
      console.log(data)
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function () {
    this.getDisciplinePenalty()
  },
  data: function () {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 20,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getDisciplinePenalty: function () {
      //   this.loading = true
      this.$http
        .get('/api/discipline-penalty', {
          params: {
            limit: this.pageSize,
            page: this.current,
          },
        })
        .then(({ data }) => {
          console.log(data)
          this.loading = false
          this.data = data.data
          console.log(this.data)
          this.meta = data.meta
        })
    },
    handleCreated: function () {
      this.getDisciplinePenalty()
    },
    handleUpdateTable: function () {
      this.getDisciplinePenalty()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getDisciplinePenalty()
    },
    onChange(current) {
      this.current = current
      this.getDisciplinePenalty()
    },
  },
}
</script>
<style>
.error {
  padding: 25px 5px;
}
</style>
